import { view } from "@/mega-ui/helpers/function"
import { getAuthenticationStore, getCustomerStore } from "@/helpers/storeHelpers"

export const offers = {
    path: '/offers',
    name: 'offers',
    children: [
        {
            path: 'main',
            name: 'offers-main',
            meta: {
                withAuth: true,
            },
            component: () => view('offers/MegaAvantagesMainView')
        },
        {
            path: 'link-accounts',
            name: 'link-accounts',
            meta: {
                withAuth: true,
            },
            beforeEnter: () => {
                const authStore = getAuthenticationStore()
                if (!authStore || !authStore.isOwner) {
                    return { name: 'not-found' }
                }
                
                const customerStore = getCustomerStore()
                if (customerStore?.energyId && customerStore?.energyLinkConfirmed) {
                    return { name: 'home' }
                }
            },
            component: () => view('offers/LinkAccountsView')
        },
    ]
}